/**
 * Decisión del analista sobre un hallazgo de Alphi.
 *
 * El API publica los valores (0, 1, 2) sin nombres; los de acá siguen los
 * contadores del análisis (`pendingFindingCount`, `discardedFindingCount`).
 */
export enum SyncAnalysisFindingDecisionEnum {
    /** Todavía nadie lo revisó. */
    Pending = 0,

    /** El analista confirma el hallazgo: hay algo que corregir o liquidar. */
    Accepted = 1,

    /** El analista lo descarta: no aplica o es un falso positivo. */
    Discarded = 2,
}
